export default "__VITE_ASSET__DrtkIOhl__"